export default [
    {
        path: '/reports/facility-data',
        name: 'reports-facility-data',
        meta: {
            title: 'FACILITY DATA REPORTS',
            icon: 'mdi-printer-outline'
        },
        component: () => import(/* webpackChunkName: "reports" */ '@/components/AppModuleNavigator.vue'),
        props: {parentRouteName: 'reports-facility-data'},
        children: [
            {
                path: 'new-construction',
                name: 'new-construction',
                component: () => import(/* webpackChunkName: "reports" */ '@/modules/reports/pages/ReportViewer.vue'),
                props: {
                    reportTitle: 'NEW CONSTRUCTION',
                    reportUrl: 'https://services.gis.msu.edu/static/facility-data-reports/NEW%20CONSTRUCTION-en-us.pdf'
                },
                meta: {
                    title: 'NEW CONSTRUCTION',
                    icon: 'mdi-printer-outline'
                }
            },
            {
                path: 'building-data-summary',
                name: 'building-data-summary',
                component: () => import(/* webpackChunkName: "reports" */ '@/modules/reports/pages/ReportViewer.vue'),
                props: {
                    reportTitle: 'BUILDING DATA SUMMARY',
                    reportUrl: 'https://services.gis.msu.edu/static/facility-data-reports/BUILDING%20DATA%20SUMMARY-en-us.pdf'
                },
                meta: {
                    title: 'BUILDING DATA SUMMARY',
                    icon: 'mdi-printer-outline'
                }
            },
            {
                path: 'building-data-list',
                name: 'building-data-list',
                component: () => import(/* webpackChunkName: "reports" */ '@/modules/reports/pages/ReportViewer.vue'),
                props: {
                    reportTitle: 'BUILDING DATA LIST',
                    reportUrl: 'https://services.gis.msu.edu/static/facility-data-reports/BUILDING%20DATA%20LIST-en-us.pdf'
                },
                meta: {
                    title: 'BUILDING DATA LIST',
                    icon: 'mdi-printer-outline'
                }
            },
            {
                path: 'chronological-building-list',
                name: 'chronological-building-list',
                component: () => import(/* webpackChunkName: "reports" */ '@/modules/reports/pages/ReportViewer.vue'),
                props: {
                    reportTitle: 'CHRONOLOGICAL BUILDING LIST',
                    reportUrl: 'https://services.gis.msu.edu/static/facility-data-reports/CHRONOLOGICAL%20LIST-en-us.pdf'
                },
                meta: {
                    title: 'CHRONOLOGICAL BUILDING LIST',
                    icon: 'mdi-printer-outline'
                }
            },
            {
                path: 'steam-electric-load',
                name: 'steam-electric-load',
                component: () => import(/* webpackChunkName: "reports" */ '@/modules/reports/pages/ReportViewer.vue'),
                props: {
                    reportTitle: 'STEAM AND ELECTRIC LOAD',
                    reportUrl: 'https://services.gis.msu.edu/static/facility-data-reports/STEAM%20AND%20ELECTRIC%20LOAD-en-us.pdf'
                },
                meta: {
                    title: 'STEAM AND ELECTRIC LOAD',
                    icon: 'mdi-printer-outline'
                }
            },
            {
                path: 'building-replacement-cost',
                name: 'building-replacement-cost',
                component: () => import(/* webpackChunkName: "reports" */ '@/modules/reports/pages/ReportViewer.vue'),
                props: {
                    reportTitle: 'BUILDING REPLACEMENT COST',
                    reportUrl: 'https://services.gis.msu.edu/static/facility-data-reports/BUILDING%20REPLACEMENT%20COST-en-us.pdf'
                },
                meta: {
                    title: 'BUILDING REPLACEMENT COST',
                    icon: 'mdi-printer-outline'
                }
            },
            {
                path: 'utility-distribution',
                name: 'utility-distribution',
                component: () => import(/* webpackChunkName: "reports" */ '@/modules/reports/pages/ReportViewer.vue'),
                props: {
                    reportTitle: 'UTILITY DISTRIBUTION',
                    reportUrl: 'https://services.gis.msu.edu/facility-data/reports/?reportname=utility-distribution'
                },
                meta: {
                    title: 'UTILITY DISTRIBUTION',
                    icon: 'mdi-printer-outline'
                }
            }
        ]
    }
]
